export const StatuspageMarkInverse = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 38.877C29.0407 38.877 33.127 34.7908 33.127 29.75C33.127 24.7093 29.0407 20.623 24 20.623C18.9593 20.623 14.873 24.7093 14.873 29.75C14.873 34.7908 18.9593 38.877 24 38.877Z"
      fill="url(#paint0_linear_818_534)"
    />
    <path
      d="M4.74302 18.132L9.67002 23.968C10.039 24.405 10.7 24.46 11.125 24.078C19.068 16.946 28.933 16.946 36.876 24.078C37.302 24.46 37.961 24.407 38.33 23.97C39.552 22.522 42.075 19.534 43.259 18.132C43.615 17.71 43.577 17.076 43.162 16.711C31.632 6.59502 16.371 6.59502 4.84102 16.711C4.42602 17.075 4.38802 17.71 4.74502 18.132H4.74302Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_534"
        x1="24"
        y1="19.144"
        x2="24"
        y2="33.053"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.4" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);
